const identifierName = /^[A-Za-z][A-Za-z0-9]*$/;

// String -> String -> void
export const validateName = (type) => (name) => {
    if (!identifierName.test(name)) {
        throw new Error(
            `Invalid ${type} name: '${name}'. Command and parameter names must start with a letter and contain only letters and numbers.`,
        );
    }
};
